module.exports = __webpack_public_path__ + "img/Hotel_dua.d54bceb7.jpg";